import React, { Component } from "react";
import LandmarksForm from './LandmarksForm'
import LandmarksView from './LandmarksView'


class Landmarks extends Component {

    render() {
        // if(this.props.isAddHotel){
        //     return (
        //         <LandmarksForm {...this.props} />
        //     )
        // }
        // else{
        // return (
        //   <LandmarksView hotel={this.props.hotel} />
        // )
        // }
        return (
            <LandmarksForm {...this.props} />
        )
    }

}

export default Landmarks


// WEBPACK FOOTER //
// src/routes/hotels/components/Landmarks.js